import { render, staticRenderFns } from "./LoadingSkeleton.vue?vue&type=template&id=03cfb5af&scoped=true"
import script from "./LoadingSkeleton.vue?vue&type=script&lang=js"
export * from "./LoadingSkeleton.vue?vue&type=script&lang=js"
import style0 from "./LoadingSkeleton.vue?vue&type=style&index=0&id=03cfb5af&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03cfb5af",
  null
  
)

export default component.exports